import { gql } from "apollo-boost";

export const GET_BLOCK_BY_ID = gql`
  query productListQuery($id: String!) {
    blockContentById(id: $id) {
      ... on BlockContentWizard {
        fieldTitle
        fieldDescription
        fieldWizardTheme
        fieldImage {
          url
        }
        fieldWizardSteps {
          entityId
          fieldTitle
          fieldDescription
          fieldWizardOptions {
            fieldIllustration
            fieldLabel
            fieldImage {
              url
            }
            fieldSelectLinkSteps
            fieldLink {
              path
            }
            fieldWizardSteps {
              entityId
            }
          }
        }
      }
    }
  }
`;

export const GET_PARAGRAPH_BY_ID = gql`
  query($id: String!) {
    paragraphById(id: $id) {
      ... on ParagraphWizardSteps {
        entityId
        fieldTitle
        fieldDescription
        fieldWizardOptions {
          fieldIllustration
          fieldLabel
          fieldImage {
            url
          }
          fieldSelectLinkSteps
          fieldLink {
            path
          }
          fieldWizardSteps {
            entityId
          }
        }
      }
    }
  }
`;
